import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
import { default as _91_46_46_46path_937tscjZcrwAMeta } from "/app/pages/[...path].vue?macro=true";
import { default as _91slug_9350gihDaK4XMeta } from "/app/pages/blog/articles/[slug].vue?macro=true";
import { default as _91slug_93OqczCn2NfnMeta } from "/app/pages/blog/categories/[slug].vue?macro=true";
import { default as _91slug_93uddTIRZcXNMeta } from "/app/pages/blog/tags/[slug].vue?macro=true";
import { default as locations_45mapOYEXdVJolxMeta } from "/app/pages/locations-map.vue?macro=true";
import { default as _91slug_93npESm7RtLcMeta } from "/app/pages/news/articles/[slug].vue?macro=true";
import { default as searchfcnTL5fl5XMeta } from "/app/pages/search.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexN6pT4Un8hYMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "path___ru",
    path: "/ru/:path(.*)*",
    meta: _91_46_46_46path_937tscjZcrwAMeta || {},
    component: () => import("/app/pages/[...path].vue")
  },
  {
    name: "path___uz",
    path: "/uz/:path(.*)*",
    meta: _91_46_46_46path_937tscjZcrwAMeta || {},
    component: () => import("/app/pages/[...path].vue")
  },
  {
    name: "path___en",
    path: "/en/:path(.*)*",
    meta: _91_46_46_46path_937tscjZcrwAMeta || {},
    component: () => import("/app/pages/[...path].vue")
  },
  {
    name: "blog-articles-slug___ru",
    path: "/ru/blog/articles/:slug()",
    meta: _91slug_9350gihDaK4XMeta || {},
    component: () => import("/app/pages/blog/articles/[slug].vue")
  },
  {
    name: "blog-articles-slug___uz",
    path: "/uz/blog/articles/:slug()",
    meta: _91slug_9350gihDaK4XMeta || {},
    component: () => import("/app/pages/blog/articles/[slug].vue")
  },
  {
    name: "blog-articles-slug___en",
    path: "/en/blog/articles/:slug()",
    meta: _91slug_9350gihDaK4XMeta || {},
    component: () => import("/app/pages/blog/articles/[slug].vue")
  },
  {
    name: "blog-categories-slug___ru",
    path: "/ru/blog/categories/:slug()",
    meta: _91slug_93OqczCn2NfnMeta || {},
    component: () => import("/app/pages/blog/categories/[slug].vue")
  },
  {
    name: "blog-categories-slug___uz",
    path: "/uz/blog/categories/:slug()",
    meta: _91slug_93OqczCn2NfnMeta || {},
    component: () => import("/app/pages/blog/categories/[slug].vue")
  },
  {
    name: "blog-categories-slug___en",
    path: "/en/blog/categories/:slug()",
    meta: _91slug_93OqczCn2NfnMeta || {},
    component: () => import("/app/pages/blog/categories/[slug].vue")
  },
  {
    name: "blog-tags-slug___ru",
    path: "/ru/blog/tags/:slug()",
    meta: _91slug_93uddTIRZcXNMeta || {},
    component: () => import("/app/pages/blog/tags/[slug].vue")
  },
  {
    name: "blog-tags-slug___uz",
    path: "/uz/blog/tags/:slug()",
    meta: _91slug_93uddTIRZcXNMeta || {},
    component: () => import("/app/pages/blog/tags/[slug].vue")
  },
  {
    name: "blog-tags-slug___en",
    path: "/en/blog/tags/:slug()",
    meta: _91slug_93uddTIRZcXNMeta || {},
    component: () => import("/app/pages/blog/tags/[slug].vue")
  },
  {
    name: "index___ru",
    path: "/ru",
    meta: indexN6pT4Un8hYMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___uz",
    path: "/uz",
    meta: indexN6pT4Un8hYMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexN6pT4Un8hYMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "locations-map___ru",
    path: "/ru/locations-map",
    meta: locations_45mapOYEXdVJolxMeta || {},
    component: () => import("/app/pages/locations-map.vue")
  },
  {
    name: "locations-map___uz",
    path: "/uz/locations-map",
    meta: locations_45mapOYEXdVJolxMeta || {},
    component: () => import("/app/pages/locations-map.vue")
  },
  {
    name: "locations-map___en",
    path: "/en/locations-map",
    meta: locations_45mapOYEXdVJolxMeta || {},
    component: () => import("/app/pages/locations-map.vue")
  },
  {
    name: "news-articles-slug___ru",
    path: "/ru/news/articles/:slug()",
    meta: _91slug_93npESm7RtLcMeta || {},
    component: () => import("/app/pages/news/articles/[slug].vue")
  },
  {
    name: "news-articles-slug___uz",
    path: "/uz/news/articles/:slug()",
    meta: _91slug_93npESm7RtLcMeta || {},
    component: () => import("/app/pages/news/articles/[slug].vue")
  },
  {
    name: "news-articles-slug___en",
    path: "/en/news/articles/:slug()",
    meta: _91slug_93npESm7RtLcMeta || {},
    component: () => import("/app/pages/news/articles/[slug].vue")
  },
  {
    name: "search___ru",
    path: "/ru/search",
    meta: searchfcnTL5fl5XMeta || {},
    component: () => import("/app/pages/search.vue")
  },
  {
    name: "search___uz",
    path: "/uz/search",
    meta: searchfcnTL5fl5XMeta || {},
    component: () => import("/app/pages/search.vue")
  },
  {
    name: "search___en",
    path: "/en/search",
    meta: searchfcnTL5fl5XMeta || {},
    component: () => import("/app/pages/search.vue")
  }
]